import { weenatIntl as wintl } from '@weenat/wintl';
export function getFeaturesBulletPoints(plan) {
    const basePath = 'ecommerce.plans.features_bullet_points';
    const pointsByPlan = {
        essential: ['forecasts_on_2_plots', 'forecasts_over_4_days', 'rain_alerts', 'weephyt'],
        plus: [
            'data_one_app',
            'forecasts_over_15_days',
            'agro_weather_alerts',
            'unlimited_history',
            'dss_interoperability',
            'unlimited_connections',
            { isDisabled: true, point: 'irrigation_devices_connection' },
            { isDisabled: true, point: 'meteo_vision' }
        ],
        expert: [
            'data_one_app',
            'forecasts_over_15_days',
            'agro_weather_alerts',
            'unlimited_history',
            'dss_interoperability',
            'unlimited_connections',
            'irrigation_devices_connection',
            'meteo_vision'
        ]
    };
    const translations = pointsByPlan[plan].map((strOrPoint) => {
        const isStr = typeof strOrPoint === 'string';
        const value = isStr ? strOrPoint : strOrPoint.point;
        return {
            id: value,
            label: wintl.t(`${basePath}.${value}`),
            ...(isStr ? {} : { isDisabled: strOrPoint.isDisabled })
        };
    });
    return translations;
}
